import { METADATA_KEYS } from '../DebugPanel/decorators';
export function getSchema(settings) {
    if (!(window.Reflect && Reflect.getMetadata)) {
        return undefined;
    }
    return Reflect.getMetadata(METADATA_KEYS.SCHEMA, settings.constructor.prototype);
}
//# sourceMappingURL=getSchema.js.map